import { useEffect, useRef, useState } from 'react'

export default function OverflowAwareContainer({ className = '', children }) {
  const containerRef = useRef(null)
  const [hasVerticalOverflow, setHasVerticalOverflow] = useState(false)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    const evaluateOverflow = () => {
      const nextHasVerticalOverflow = container.scrollHeight > container.clientHeight + 1
      setHasVerticalOverflow((currentValue) => (currentValue === nextHasVerticalOverflow ? currentValue : nextHasVerticalOverflow))
    }

    evaluateOverflow()

    const resizeObserver = new ResizeObserver(evaluateOverflow)
    resizeObserver.observe(container)

    const resizeTarget = container.firstElementChild
    if (resizeTarget) {
      resizeObserver.observe(resizeTarget)
    }

    window.addEventListener('resize', evaluateOverflow)

    return () => {
      window.removeEventListener('resize', evaluateOverflow)
      resizeObserver.disconnect()
    }
  }, [])

  const normalizedClassName = ['overflow-aware', className, hasVerticalOverflow ? 'is-overflowing' : 'is-contained']
    .filter(Boolean)
    .join(' ')

  return (
    <div ref={containerRef} className={normalizedClassName} data-overflow={hasVerticalOverflow ? 'enabled' : 'disabled'}>
      {children}
    </div>
  )
}
